<script setup lang="ts">
import { useRoute } from 'vue-router';
import CoreIcon from '@core/core-icon.vue';
const props = defineProps({
	list: {
		type: Array,
		default: () => []
	},
	group: {
		type: String,
		default: ""
	},
	availableIndex: {
		type: Number,
		default: 0
	}
});
const route = useRoute();
</script>
<template>
	<ul :class="['part-counter-list', {
		'part-counter-list_centered': list.length < 3
	}]">
		<li
			v-for="(item, index) in list" :key="item.routeName"
			:class="['part-counter-list__item', {
				'part-counter-list__item_active': route.name === item.routeName,
				'part-counter-list__item_complete': item?.complete,
			}]"
		>
			<component
				:is="index <= availableIndex ? 'router-link' : 'span'"
				:to="index <= availableIndex ? {name: item.routeName, params: { groupName: group }} : null"
				class="part-counter-list__link"
			>
				<span class="part-counter-list__counter">
					<core-icon
						v-if="item?.complete"
						name="checkmark"
						viewBox="0 0 15 14"
						class="part-counter-list__complete"
					/>
				</span>
				<span class="part-counter-list__title">
					{{ $t(item.headName	) }}
				</span>
			</component>
		</li>
	</ul>
</template>

<style lang="scss">
.part-counter-list {
	display: flex;
	justify-content: space-between;
	counter-reset: list;
	gap: 3rem;

	@include min-desktop {
		gap: 2.4rem;
	}

	&_centered {
		justify-content: center;
	}

	&__item {
		display: block;

		&_complete {
			// color: #fff;
			.part-counter-list {
				&__counter {
					border: none;
					background-color: var(--color-panel);
					@include theme-dark {
						box-shadow: inset 1px 1px 1px 0px var(--color-panel);
					}
				}
				&__title {
					// opacity: 1;
				}
			}
		}

		&_active {
			.part-counter-list {
				&__counter {
					background: var(--color-purple);
					box-shadow: inset 0px 0px 24px rgba(255, 255, 255, 0.5);
					color: var(--color-white);
					border-color: rgba(255, 255, 255, 0.5);
				}
				&__complete {
					fill: var(--color-white);
				}
			}
		}
	}

	&__title {
		text-align: center;
		display: block;
	}

	&__link {
		display: block;
	}

	&__link-inner {
		display: block;
	}

	&__complete {
		width: 1.4rem;
		fill: var(--color-active);
		stroke-width: 2;
		// animation: scale-up 1s ease 0s 1;
		@include min-desktop {
			width: 1.8rem;
		}
	}

	&__counter {
		width: 4.6rem;
		height: 4.6rem;
		border-radius: 50%;
		border: 1px solid var(--color-active);
		background-color: var(--color-panel);
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: auto;
		margin-right: auto;
		margin-bottom: 1.2rem;
		counter-increment: list;
		transition: ease .25s;
		color: var(--color-active);

		@include theme-dark {
			border-color: var(--color-panel);
		}
		@include min-desktop {
			width: 6.4rem;
			height: 6.4rem;
			&::before {
				@include font-18-pro-medium;
			}
		}

		&:empty {
			&::before {
				content: counters(list, "", decimal-leading-zero);
			}
		}
	}
}
</style>
